import { motion } from "framer-motion";
import { Sparkles, MessageCircle } from "lucide-react";
import ChatInterface from "./ChatInterface";

export default function MainInterface({
  messages,
  isLoading,
  onSend,
  onNewChat,
  onSourceClick,
  confidence
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="max-w-4xl mx-auto"
    >
      {/* Ask Anything Card - Full width, centered */}
      <div className="relative h-[700px]">
        {/* Glow effect behind the card */}
        <div className="absolute -inset-1 bg-gradient-to-r from-[#00d4aa] via-[#6ee7c2] to-[#00d4aa] rounded-3xl blur-lg opacity-25 animate-pulse-slow" />
        
        <div className="relative bg-[#0c0c14] rounded-2xl overflow-hidden flex flex-col border-2 border-[#00d4aa]/40 shadow-[0_0_50px_rgba(0,212,170,0.15)] h-full">
          {/* Highlighted Header */}
          <div className="px-6 py-5 border-b border-[#00d4aa]/20 bg-gradient-to-r from-[#00d4aa]/10 to-[#6ee7c2]/5 flex items-center justify-between flex-shrink-0">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#00d4aa] to-[#6ee7c2] flex items-center justify-center shadow-lg shadow-[#00d4aa]/20">
                <MessageCircle className="w-5 h-5 text-[#0a0a0f]" />
              </div>
              <div>
                <h3 className="text-[#f0f0f5] font-bold text-xl" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  Ask Anything
                </h3>
                <p className="text-[#6ee7c2] text-sm">
                  Conversational RAG interface
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 bg-[#00d4aa]/15 rounded-full border border-[#00d4aa]/30">
              <Sparkles className="w-4 h-4 text-[#6ee7c2]" />
              <span className="text-[#6ee7c2] text-sm font-medium">AI powered</span>
            </div>
          </div>
          
          <div className="flex-1 overflow-hidden">
            <ChatInterface
              messages={messages}
              isLoading={isLoading}
              onSend={onSend}
              onNewChat={onNewChat}
              onSourceClick={onSourceClick}
              confidence={confidence}
            />
          </div>
        </div>
      </div>
    </motion.div>
  );
}
